/* eslint-disable import/prefer-default-export */
import React from 'react'

import { SimpleSwiper, SwiperSlide } from 'components/generic/SimpleSlider'
import s from './WhoNooklynFor.module.css'

import renters from './renters.jpg'
import agents from './agents.jpg'
import landlords from './landlords.jpg'

const FEATURES = [
  {
    icon: renters,
    title: <>Renters</>,
    text: <>Nooklyn helps you find your next home with curated listings and seamless applications.</>,
    link: {
      text: <>find your nook with us</>,
      url: '/contact',
    },
  },
  {
    icon: agents,
    title: <>Agents</>,
    text: <>Streamline your workflow, showcase your listings, and connect with serious renters—fast and hassle-free.</>,
    link: {
      text: <>work with us</>,
      url: '/work',
    },
  },
  {
    icon: landlords,
    title: <>Landlords</>,
    text: (
      <>
        Fill vacancies quickly with access to qualified renters, verified applications, and support from a trusted team.
      </>
    ),
    link: {
      text: <>let us work for you</>,
      url: '/business',
    },
  },
]

export function WhoNooklynFor() {
  return (
    <div className={s.root}>
      <h2 className={s.title}>Who’s Nooklyn for?</h2>

      <div className={s.features}>
        {FEATURES.map(feature => (
          <div className={s.feature}>
            <div className={s.featureIcon}>
              <img src={feature.icon} className={s.featureImage} alt="feature" />
            </div>
            <div className={s.featureTitle}>{feature.title}</div>
            <div className={s.featureText}>{feature.text}</div>
            {feature.link && (
              <a className={s.featureLink} href={feature.link.url}>
                {feature.link.text}
              </a>
            )}
          </div>
        ))}
      </div>

      <div className={s.slider}>
        <SimpleSwiper className={s.sliderWrapper} slidesPerView={1} spaceBetween={20} pagination>
          {FEATURES.map((feature, index) => (
            <SwiperSlide key={index}>
              <div className={s.feature}>
                <div className={s.featureIcon}>
                  <img src={feature.icon} className={s.featureImage} alt="feature" />
                </div>
                <div className={s.featureTitle}>{feature.title}</div>
                <div className={s.featureText}>{feature.text}</div>
                {feature.link && (
                  <a className={s.featureLink} href={feature.link.url}>
                    {feature.link.text}
                  </a>
                )}
              </div>
            </SwiperSlide>
          ))}
        </SimpleSwiper>
      </div>
    </div>
  )
}
